"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class Feature {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "eCommerce", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "premiumShop", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "nativeShop", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "mapMode", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "courierServices", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "routeOptimization", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "referKit", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "rentals", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Feature.prototype, "supershop", void 0);
exports.Feature = Feature;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZXMuanMiLCJzb3VyY2VSb290IjoiLi9zcmMvIiwic291cmNlcyI6WyJwYWNrYWdlcy9tb2RlbHMvc3JjL2ZlYXR1cmVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxxQ0FBaUM7QUFFakMsTUFBYSxPQUFPO0NBNEJuQjtBQTFCRztJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzs7MENBQ1A7QUFFbkI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUM7OzRDQUNOO0FBRXJCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDOzsyQ0FDUDtBQUVwQjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQzs7d0NBQ1Y7QUFFakI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUM7O2dEQUNGO0FBRXpCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDOztrREFDQTtBQUUzQjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsQ0FBQzs7eUNBQ1Q7QUFFbEI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLENBQUM7O3dDQUNWO0FBRWpCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDOzswQ0FDUjtBQTNCdkIsMEJBNEJDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29sdW1uIH0gZnJvbSBcInR5cGVvcm1cIjtcblxuZXhwb3J0IGNsYXNzIEZlYXR1cmUge1xuXG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IHRydWUgfSlcbiAgICBlQ29tbWVyY2U6IGJvb2xlYW47XG5cbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogZmFsc2UgfSlcbiAgICBwcmVtaXVtU2hvcDogYm9vbGVhbjtcblxuICAgIEBDb2x1bW4oeyBkZWZhdWx0OiBmYWxzZSB9KVxuICAgIG5hdGl2ZVNob3A6IGJvb2xlYW47XG5cbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogZmFsc2UgfSlcbiAgICBtYXBNb2RlOiBib29sZWFuO1xuXG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IGZhbHNlIH0pXG4gICAgY291cmllclNlcnZpY2VzOiBib29sZWFuO1xuXG4gICAgQENvbHVtbih7IGRlZmF1bHQ6IGZhbHNlIH0pXG4gICAgcm91dGVPcHRpbWl6YXRpb246IGJvb2xlYW47XG5cbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogZmFsc2UgfSlcbiAgICByZWZlcktpdDogYm9vbGVhbjtcblxuICAgIEBDb2x1bW4oeyBkZWZhdWx0OiBmYWxzZSB9KVxuICAgIHJlbnRhbHM6IGJvb2xlYW47XG5cbiAgICBAQ29sdW1uKHsgZGVmYXVsdDogZmFsc2UgfSlcbiAgICBzdXBlcnNob3A6IGJvb2xlYW47XG59Il19